var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createUseStyles } from "react-jss";
import { THEME } from "./theming";
export var useIconClasses = function (iconType, color, iconOnly) {
    var useStyles = createUseStyles({
        icon: __assign(__assign(__assign(__assign({}, BASE_ICON), (iconType && ICON_STYLES[iconType].icon)), { color: color !== null && color !== void 0 ? color : THEME.palette.gray.slate.color }), (iconOnly ? { width: 18, paddingRight: 0 } : {})),
    });
    return useStyles();
};
var BASE_ICON = {
    paddingRight: 8,
};
var ICON_STYLES = {
    glyphicon: {
        icon: {
            top: 2,
            width: 20,
        },
    },
    "glyphicon-pro": {
        icon: {
            width: 24,
            fontSize: 18,
            marginLeft: 0,
        },
    },
};
